<template>
  <v-row class="mb-5">
    <v-col xs="12" sx="12" :md="size" :xl="size">
      <v-card flat :loading="loading">
        <v-card-title>
          Gestione immagini prodotto
        </v-card-title>
        <v-card-text>
          <v-file-input class="mt-2 text-caption" accept="*.*" label="Carica il file da archiviare" show-size outlined
            multiple clearable prepend-icon="" prepend-inner-icon="$file" :hint="elencoFile"
            :persistent-hint="!!elencoFile" @change="onChangeMultiple" @click:clear.stop="onClearFile">
          </v-file-input>
        </v-card-text>
        <v-card-title>
          Elenco file caricati
          <v-btn icon class="ml-3">
            <v-icon @click="getDirList">mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <file-list :files="files" :moduli="moduli" @delete="onDeleteFile" @refresh="getDirList"
            @change="onChangeFileList" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-5" @click="salvaImmagini">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  // import utility from '@/services/utilityService'
  import configurazioni from '@/services/configurazioniService'
  import FileList from './fileList'

  export default {
    components: {
      FileList
    },
    props: {
      idProdotto: String,
      allegati: Array,
      triggerUpdate: Number,
      size: { type: Number, default: 6 }
    },
    data() {
      return {
        elencoFile: '',
        loading: false,
        files: [],
        moduli: []
      }
    },
    async mounted() {
      // console.log('allegati', this.allegati)
      await this.getDirList()
      // await this.getModuleVersion()
    },
    watch: {
      allegati(value) {
        // this.files = this.allegati
        Object.assign(this.files, this.allegati)
      },
      async triggerUpdate() {
        await this.getDirList()
      }
    },
    methods: {
      onClearFile() {
        this.elencoFile = ''
      },
      async onChangeMultiple(files) {
        if (!files || files.length === 0) {
          return
        }
        this.loading = true
        const info = await configurazioni.getInfoUpload()
        const form_data = new FormData();
        const aggiunti = []
        for (let ff of files) {
          const esistente = this.allegati.find(x => x.name === ff.name)
          form_data.append('attachment_multiple', ff, ff.name)
          let daAggiungere = {
            name: ff.name,
            date: new Date(),
            description: { codice: 'eCommerce', descrizione: 'eCommerce' },
            type: ff.type,
            size: ff.size,
            lastModified: ff.lastModifiedDate,
            // pathFile: `${info.service}/utility/attachments/file?base=${info.base}&prodotto=${this.idProdotto}&fn=${ff.name}`
            pathFile: `${info.service}/utility/attachments/filename/${ff.name}?base=${info.base}&prodotto=${this.idProdotto}`
          }
          if (esistente) {
            daAggiungere.codice = esistente.codice
          }
          aggiunti.push(daAggiungere)
        }
        await configurazioni.uploadRepositoryMultipleFile(form_data, info.service, info.base, null, this.idProdotto)

        this.$emit('change', { idProdotto: this.idProdotto, tipo: 'addFile', payload: aggiunti })
        await this.getDirList()
        // await this.getModuleVersion()
        this.loading = false
      },
      async getDirList() {
        this.$emit('refresh')
        try {
          this.files = Object.assign([], this.allegati)
        } catch (err) {
          console.log(err)
        }
      },
      async onDeleteFile(file) {
        const info = await configurazioni.getInfoUpload()
        await configurazioni.deleteAttachmentFile(info.service, info.base, null, this.idProdotto, null, file.name)
        this.$emit('change', { idProdotto: this.idProdotto, tipo: 'deleteFile', payload: file })
      },
      onChangeFileList(file) {
        this.$emit('change', { idProdotto: this.idProdotto, tipo: 'updateFile', payload: [file] })
      },
      async salvaImmagini() {
        // TODO: Gestire
      }
    }
  }
</script>
